import {inject, Injectable} from '@angular/core';
import {PreviewFileUrlsStateService} from "../../../../services/preview-file-urls-state.service";
import {GetFileIdParams} from "../types/preview-file-modal.types";

@Injectable({
  providedIn: 'root'
})
export class PreviewFileModalService {
  private previewFileUrlsStateService: PreviewFileUrlsStateService = inject(PreviewFileUrlsStateService);

  public getNewFileId({ fileType, fileId, direction }: GetFileIdParams): number {
    const fileUrlsState = this.previewFileUrlsStateService.previewFileUrlsState();
    const fileIds = fileUrlsState?.[fileType] || [];
    const currentIndex = fileIds.indexOf(fileId);
    const newIndex = currentIndex === -1
      ? (direction === 1 ? 0 : fileIds.length - 1)
      : ((currentIndex + direction + fileIds.length) % fileIds.length);

    return fileIds[newIndex]
  }

  public readonly navigationMap = new Map<string, -1 | 1>([
    ['ArrowLeft', -1],
    ['ArrowRight', 1]
  ]);
}
